<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @isPickup="isPickup"
      @isVehicle="isVehicle"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchVehicles="batchVehicles"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <SetPickup
      :waybillCode="setPickupOptions.waybillCode"
      :visible.sync="setPickupOptions.visible"
      @reload="reload"
    />
    <SetVehicle
      :listCode="setVehicleOptions.listCode"
      :visible.sync="setVehicleOptions.visible"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import SetPickup from '../set-pickup'
import SetVehicle from '../set-vehicle'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader, SetPickup, SetVehicle },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      setPickupOptions: { waybillCode: '', visible: false },
      setVehicleOptions: { listCode: [], visible: false },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .bizWaybillWeightListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    isPickup({ waybillCode }) {
      this.setPickupOptions = { waybillCode, visible: true }
    },
    isVehicle(listCode) {
      this.setVehicleOptions = { listCode, visible: true }
    },
    batchVehicles() {
      const data = this.$refs.main.getCheckboxRecords()
      if (!data) {
        this.$message.warning('请选择需要更新车辆信息的运单')
        return
      }
      const listCode = data.map((item) => item.waybillCode)
      this.isVehicle(listCode)
    },
  },
}
</script>
